"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.percentile = percentile;
/**
 * Calculate the p-th percentile of a numeric array.
 * Returns 0 for empty arrays.
 */
function percentile(values, p) {
    if (values.length === 0)
        return 0;
    const sorted = values.toSorted((a, b) => a - b);
    const index = Math.ceil(p * sorted.length) - 1;
    return sorted[Math.max(0, index)];
}
